import React, { useState } from 'react';
import { Container, Card, Button, Title, Subtitle, TabButton, RulesContent } from '../../styles/GlobalStyles';

const RulesScreen = ({ onBack, translations, language }) => {
  const [activeTab, setActiveTab] = useState('rules');
  const t = translations[language];

  const rulesContent = `
Rikken is een Brabants en Limburgs kaartspel dat met vier spelers wordt gespeeld.

**Algemene regels:**
• Het spel wordt gespeeld met alle 52 speelkaarten zonder jokers
• De laagste kaart is de 2 en de hoogste de aas
• Het eerste bod wat men zegt blijft gehandhaafd
• 'Gerikt' is definitief

**Het bieden:**
De speler links van de deler brengt als eerste een bod uit. Dit blijft zich herhalen totdat het hoogste bod is bereikt. Zodra een speler gepast heeft mag die niet meer meebieden.

**Mogelijke biedingen (van laag naar hoog):**
1. Troela (Drie azen)
2. Rik
3. Betere rik
4. Acht alleen
5. Piek
6. Negen alleen
7. Misère
8. Tien alleen
9. Open piek
10. Elf alleen
11. Open misère
12. Open piek met een praatje
13. Twaalf alleen
14. Open misère met een praatje
15. Dertien alleen
16. Schoppen mie

**Het spel:**
Als men rikt, maakt men een kleur troef en vraagt men een maat mee. De maat is pas officieel bekend als degene die rikt de vraagaas gooit.

**Passpellen:**
Wanneer iedereen past, worden er speciale spellen gespeeld zoals:
• Één of vijf - iedereen moet precies 1 of 5 slagen halen
• Schoppen dame - men mag de schoppen dame en laatste slag niet krijgen
  `;

  const pointSystemContent = `
**Puntensysteem voor Rikken:**

**Troela:**
- Gehaald: 10 punten + 5 punten per overslag
- Niet gehaald: 10 punten + 5 punten per onderslag

**Rik/Betere rik:**
- Gehaald: 10 punten + 5 punten per overslag
- Kapot spelen bonus: +35 punten (alle 13 slagen)
- Niet gehaald: Rikker betaalt 10 + 5 per onderslag, maat verliest niets

**Alleen spellen:**
- Acht alleen: 10 punten ± 5 per slag verschil
- Negen alleen: 20 punten ± 5 per slag verschil
- Tien alleen: 30 punten ± 5 per slag verschil
- Elf alleen: 40 punten ± 5 per slag verschil
- Twaalf alleen: 50 punten ± 5 per slag verschil
- Dertien alleen: 70 punten (vast)

**Speciale spellen (kernwaarden):**
- Piek: 15 punten (geen slagen halen)
- Misère: 25 punten (geen slagen halen)
- Open piek: 40 punten
- Open misère: 50 punten
- Open piek met praatje: 55 punten
- Open misère met praatje: 60 punten

**Passpellen:**
- Schoppen mie: 5 punten per slag
- Één of vijf: 10 punten voor wie precies 1, (3) of 5 slagen haalt


Gedetailleerde puntentabellen

Piek

(Kolommen: Rik/team en de scores voor de vier spelers in volgorde)

1 speler
- GESLAAGD = 1: 45, -15, -15, -15
- GESLAAGD = 0: -45, 15, 15, 15

2 spelers
- GESLAAGD = 0: -30, -30, 30, 30
- GESLAAGD = 1: 45, -45, 0, 0
- GESLAAGD = 2: 30, 30, -30, -30

3 spelers
- GESLAAGD = 0: -15, -15, -15, 45
- GESLAAGD = 1: 45, -30, -30, 15
- GESLAAGD = 2: 30, 30, -45, -15
- GESLAAGD = 3: 15, 15, 15, -45

Miserie

1 speler
- GESLAAGD = 1: 75, -25, -25, -25
- GESLAAGD = 0: -75, 25, 25, 25

2 spelers
- GESLAAGD = 0: -50, -50, 50, 50
- GESLAAGD = 1: 75, -75, 0, 0
- GESLAAGD = 2: 50, 50, -50, -50

3 spelers
- GESLAAGD = 0: -25, -25, -25, 75
- GESLAAGD = 1: 75, -50, -50, 25
- GESLAAGD = 2: 50, 50, -75, -25
- GESLAAGD = 3: 25, 25, 25, -75

Open Piek

1 speler
- GESLAAGD = 1: 120, -40, -40, -40
- GESLAAGD = 0: -120, 40, 40, 40

2 spelers
- GESLAAGD = 0: -80, -80, 80, 80
- GESLAAGD = 1: 120, -120, 0, 0
- GESLAAGD = 2: 80, 80, -80, -80

3 spelers
- GESLAAGD = 0: -40, -40, -40, 120
- GESLAAGD = 1: 120, -80, -80, 40
- GESLAAGD = 2: 80, 80, -120, -40
- GESLAAGD = 3: 40, 40, 40, -120

Open Piek met Praatje

1 speler
- GESLAAGD = 1: 165, -55, -55, -55
- GESLAAGD = 0: -165, 55, 55, 55

2 spelers
- GESLAAGD = 0: -110, -110, 110, 110
- GESLAAGD = 1: 165, -165, 0, 0
- GESLAAGD = 2: 110, 110, -110, -110

3 spelers
- GESLAAGD = 0: -55, -55, -55, 165
- GESLAAGD = 1: 165, -110, -110, 55
- GESLAAGD = 2: 110, 110, -165, -55
- GESLAAGD = 3: 55, 55, 55, -165

Open Miserie met Praatje

1 speler
- GESLAAGD = 1: 180, -60, -60, -60
- GESLAAGD = 0: -180, 60, 60, 60

2 spelers
- GESLAAGD = 0: -120, -120, 120, 120
- GESLAAGD = 1: 180, -180, 0, 0
- GESLAAGD = 2: 120, 120, -120, -120

3 spelers
- GESLAAGD = 0: -60, -60, -60, 180
- GESLAAGD = 1: 180, -120, -120, 60
- GESLAAGD = 2: 120, 120, -180, -60
- GESLAAGD = 3: 60, 60, 60, -180
  `;

  return (
    <Container>
      <Title>{language === 'nl' ? 'Spelregels' : 'Game Rules'}</Title>

      <Card>
        <div style={{ display: 'flex', marginBottom: '8px', borderBottom: '2px solid #000' }}>
          <TabButton
            active={activeTab === 'rules'}
            onClick={() => setActiveTab('rules')}
          >
            {language === 'nl' ? 'Spelregels' : 'Rules'}
          </TabButton>
          <TabButton
            active={activeTab === 'points'}
            onClick={() => setActiveTab('points')}
          >
            {t.pointSystem}
          </TabButton>
        </div>

        <RulesContent>
          {activeTab === 'rules' && (
            <div>
              {rulesContent.split('\n').map((line, index) => {
                if (line.startsWith('**') && line.endsWith('**')) {
                  return <h4 key={index}>
                    {line.replace(/\*\*/g, '')}
                  </h4>;
                }
                if (line.startsWith('•')) {
                  return <li key={index}>
                    {line.substring(1).trim()}
                  </li>;
                }
                if (line.match(/^\d+\./)) {
                  return <li key={index}>
                    {line}
                  </li>;
                }
                return line.trim() ? <p key={index}>{line}</p> : <br key={index} />;
              })}
            </div>
          )}

          {activeTab === 'points' && (
            <div>
              {pointSystemContent.split('\n').map((line, index) => {
                if (line.startsWith('**') && line.endsWith('**')) {
                  return <h4 key={index}>
                    {line.replace(/\*\*/g, '')}
                  </h4>;
                }
                if (line.startsWith('- ')) {
                  return <li key={index}>
                    {line.substring(2)}
                  </li>;
                }
                return line.trim() ? <p key={index}>{line}</p> : <br key={index} />;
              })}
            </div>
          )}
        </RulesContent>

        <Button variant="secondary" onClick={onBack}>
          {t.back}
        </Button>
      </Card>
    </Container>
  );
};

export default RulesScreen;
